import { RubikText } from '@client/game/components/RubikText'
import { MainScene } from '@client/game/scenes/MainScene'
import { useCursorOpen, useCursorPointer } from '@client/misc/cursor'
import Phaser from 'phaser'

export class FeedbackLinkButton extends Phaser.GameObjects.Container {
	public background: Phaser.GameObjects.NineSlice
	public textObj: RubikText

	constructor(scene: MainScene, x: number, y: number) {
		super(scene, x, y)

		this.textObj = new RubikText(scene, 0, 0, 'Feedback', {
			fontSize: '18px',
			fontStyle: 'bold',
			stroke: 'black',
			strokeThickness: 6,
		}).setOrigin(0.5, 0.5)
		this.setVisible(false)
		this.setActive(false)

		this.background = scene.add.nineslice(
			0,
			0,
			'Button01_Purple',
			undefined,
			this.textObj.width + 40,
			this.textObj.height,
			25,
			25
		)
		this.setSize(this.background.width, this.background.height)
		this.setInteractive()
			.on('pointerdown', () => {
				scene.discordSdk.commands.openExternalLink({ url: 'https://forms.gle/VgQjTz75bGBzWnJXA' })
				this.scene.sound.play('Card_Game_UI_General_Echo_01')
			})
			.on('pointerover', () => {
				useCursorOpen(this.scene)
				this.background.setTint(0x2a1b3d)
				this.scene.sound.play('Card_Game_UI_Button_Light_Reverb_02')
			})
		this.on('pointerout', () => {
			useCursorPointer(this.scene)
			this.background.clearTint()
		})

		this.add(this.background)
		this.add(this.textObj)
		this.updateText(this.textObj.text)

		scene.add.existing(this)
	}

	public disableAndHide() {
		this.setVisible(false)
		this.setActive(false)
	}

	public enableAndShow() {
		this.setVisible(true)
		this.setActive(true)
	}

	public updateText(text: string) {
		this.textObj.text = text
		this.background.setSize(this.textObj.width + 40, 30)
		this.background.setDisplaySize(this.textObj.width + 40, this.textObj.height + 40)
		this.setSize(this.background.width, this.background.height)
	}
}
